

export const ELECTRONIC_DELIVERY = 'DIGITAL';
export const PHYSICAL_DELIVERY = 'PHYSICAL';
